module.exports = __webpack_public_path__ + "static/img/5.e18bb214.png";